export const CAREPLAN_ADL_PBS_ID = '65e65524a07c451a8b4370fd'
